/**
 * Hero Slideshow - ドット・矢印で切り替えるスライドショー
 * スマホ版・PC版の両方をサポート
 * 進む・戻るの両方向でアニメーション
 */
(function() {
  'use strict';

  var time = 3000;

  function initSlideshow(containerId) {
    var cont = document.getElementById(containerId);
    if (!cont) return;

    var slides = cont.querySelectorAll('.slide');
    var slideDots = cont.querySelectorAll('.dot');
    if (slides.length === 0) return;

    var i = -1;
    var slideTimer;
    var hasInteracted = false;

    function clickChangeSlide(n) {
      clearTimeout(slideTimer);
      changeSlide(n, true);
    }

    function changeSlide(n, manual) {
      if (manual === undefined) manual = false;
      if (n === undefined) n = i;

      var prevI = i;
      var direction = 'next';

      var j;
      for (j = 0; j < slides.length; j++) {
        if (j === i) {
          slides[j].classList.add('prev-slide');
          slides[j].classList.remove('active-slide');
          if (slideDots[j]) slideDots[j].classList.remove('active-dot');
          continue;
        }
        if (slideDots[j]) slideDots[j].classList.remove('active-dot');
        slides[j].classList.remove('prev-slide');
        slides[j].classList.remove('active-slide');
      }

      if (manual) {
        hasInteracted = true;
        cont.classList.remove('initial-load');
        if (n < 0) {
          i = slides.length - 1;
          direction = 'prev';
        } else if (n > slides.length - 1) {
          i = 0;
          direction = 'next';
        } else {
          direction = n > prevI ? 'next' : 'prev';
          i = n;
        }
      } else {
        direction = 'next';
        i = i < slides.length - 1 ? i + 1 : 0;
      }

      cont.dataset.direction = direction;
      slides[i].classList.add('active-slide');
      if (slideDots[i]) slideDots[i].classList.add('active-dot');

      slideTimer = setTimeout(function() {
        changeSlide();
      }, time);
    }

    var leftArrow = cont.querySelector('.arrow-button.left-arrow');
    var rightArrow = cont.querySelector('.arrow-button.right-arrow');

    for (var d = 0; d < slideDots.length; d++) {
      (function(idx) {
        slideDots[idx].addEventListener('click', function() {
          clickChangeSlide(idx);
        });
        slideDots[idx].addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            clickChangeSlide(idx);
          }
        });
      })(d);
    }

    if (leftArrow) {
      leftArrow.addEventListener('click', function() {
        clickChangeSlide(i - 1);
      });
    }
    if (rightArrow) {
      rightArrow.addEventListener('click', function() {
        clickChangeSlide(i + 1);
      });
    }

    /* 1枚目が既に active-slide なら初期化のみ（黒フラッシュ防止） */
    var initialActive = cont.querySelector('.slide.active-slide');
    if (initialActive) {
      cont.classList.add('initial-load');
      i = Array.prototype.indexOf.call(slides, initialActive);
      if (i < 0) i = 0;
      if (slideDots[i]) slideDots[i].classList.add('active-dot');
      slideTimer = setTimeout(function() { changeSlide(); }, time);
    } else {
      changeSlide();
    }
  }

  function init() {
    initSlideshow('hoshiki-hero-slideshow-sp');
    initSlideshow('hoshiki-hero-slideshow');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
